// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8f7e1c01","389":"6fecd93c","453":"e80f2051","455":"4b6df64e","977":"a96d63b2"}[chunkId] + ".chunk.js";
};